import { getAuth, onAuthStateChanged } from "firebase/auth";

import usuario from "./usuario";




export default class ControleRank {

    constructor() {
        this.auth = getAuth();
        this.usuario = null
    }

    /////// Controle de Autenticação inicial /////
    // Conectando Pai a atualização do filho /////
    ancora(forceUpdate) {
        this.forceUpdate = forceUpdate

    }
    update(item) {
        this.forceUpdate(item);
    }

    //////////////////////////////////////////////

    init() {
        onAuthStateChanged(this.auth, (user) => {
            if (user !== null) {
                setTimeout(() => { this.update(true) }, 2000);
                this.userCreate()
            }
            else {
                setTimeout(() => { this.update(false) }, 2000);
                this.userCreate()
            }
        })
    }
    ///////////////////////////////////////////////


    userCreate() {

        if (this.verifyUser()) {
            this.usuario = new usuario(this.auth.currentUser)
        } else
            this.usuario = null
    }

    verifyUser() {

        const user = this.auth.currentUser;
        if (user !== null)
            return true
        else
            return false
    }










}